<template>
  <transition name="partner-list">
    <section class="mb-64">
      <h1 class="text-h1 mb-16">Discover more for your family*</h1>
      <div v-for="categoryKey in Object.keys(categorizedPartnerKeys)" :key="categoryKey" class="mb-48">
        <h3 class="text-h3">{{ CATEGORY_NAMES[categoryKey] }}</h3>
        <div class="flex gap-16 overflow-x-scroll lg:overflow-x-visible hide-scrollbar pb-24 pt-16 max-w-screen">
          <BHPartnerCard
            v-for="partnerKey in categorizedPartnerKeysToDisplay[categoryKey]"
            :key="partnerKey"
            :partnerKey="partnerKey"
            class="min-w-[210px] max-w-[32%]"
            variant="small"
            :headerImageUrl="ALL_PARENT_PARTNER_CARDS[partnerKey].headerImage"
            :title="ALL_PARENT_PARTNER_CARDS[partnerKey].title"
            :detailsUrl="ALL_PARENT_PARTNER_CARDS[partnerKey].detailsUrl"
            :firstLineText="`by ${ALL_PARENT_PARTNER_CARDS[partnerKey].companyName}`"
            :secondLineText="secondLineText(ALL_PARENT_PARTNER_CARDS[partnerKey].ages)"
            :observer="observer"
            openInNewWindow
            tallHeader
            @ctaClicked="ctaClicked(partnerKey)"
          />
        </div>
        <Button
          v-if="displayShowMore(categoryKey)"
          variant="text"
          href="/explore/partners"
          :value="`More ${CATEGORY_NAMES[categoryKey]}`"
          ariaLabel="Discover more for your family"
        />
      </div>
      <p class="text-caption text-grey-text-subdued">*Sittercity may receive a small commission for your purchase</p>
    </section>
  </transition>
</template>

<script lang="ts">
import BHPartnerCard from '@/components/bh_partners/BHPartnerCard.vue';
import Button from '@/components/button/Button.vue';
import partners from '@/lib/partners';
import partnersData from '@/lib/partners.data';

export default {
  name: 'CategorizedPartnersList',
  components: { BHPartnerCard, Button },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
      required: false,
    },
    zipCode: {
      type: String,
      required: false,
      default: '',
    },
  },
  data(): any {
    return {
      CATEGORY_NAMES: partnersData.CATEGORY_NAMES(),
      ALL_PARENT_PARTNER_CARDS: partnersData.ALL_PARENT_PARTNER_CARDS(),
      categorizedPartnerKeys: {},
      categorizedPartnerKeysToDisplay: {},
      categoryKeys: [],
      observer: null as any,
    };
  },
  watch: {
    categorizedPartnerKeys(newVal) {
      this.categoryKeys = Object.keys(newVal);
      for (const category in newVal) {
        if (category) {
          this.categorizedPartnerKeysToDisplay[category] = [...newVal[category]].splice(0, 3);
        }
      }
    },
    zipCode(newZip) {
      this.categorizedPartnerKeys = partners.getPartnersByCategory(newZip);
    },
  },
  mounted() {
    this.categorizedPartnerKeys = partners.getPartnersByCategory(this.zipCode);
  },
  created() {
    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: this.$el,
      threshold: 0.5,
    });
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return;
        }

        this.observer.unobserve(target);
        const key = target.getAttribute('id');
        partners.sendPartnerSegmentEvent('Partner Impression', key);
      });
    },
    secondLineText(ageRange) {
      if (ageRange) {
        if (ageRange === 'All ages') return ageRange;
        return `Ages ${ageRange}`;
      }
      return null;
    },
    displayShowMore(category) {
      if (this.categorizedPartnerKeys[category].length > 3) return true;
      return false;
    },
    ctaClicked(key) {
      partners.partnerClicked(key);
    },
  },
};
</script>
